import "./App.scss";

import React, { Component } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import ErrorHandler from "../../components/ErrorHandler";
import Notifications from "../../components/Notifications";
import { AppContextContainer } from "../../data/AppContextContainer";
import { loadEnvironment } from "../../utils/scripts";
import Empty from "../error/Empty";
import NotFound from "../error/NotFound";
import InboxContainer from "../inbox/InboxContainer";
import Login from "../login/Login";
import SearchContainer from "../search/SearchContainer";
import ThreadContainer from "../thread/ThreadContainer";
import AppRouter from "./components/AppRouter";
import AuthRoute from "./components/AuthRoute";

export default class App extends Component {
  state = {
    isEnvironmentLoaded: false,
    error: null
  };

  componentDidMount() {
    loadEnvironment()
      .then(() => {
        this.setState({ isEnvironmentLoaded: true });
      })
      .catch(error => {
        this.setState({ error });
      });
  }

  render() {
    const { isEnvironmentLoaded, error } = this.state;

    if (error) {
      return <p className="App-loading">{error}</p>;
    }

    if (!isEnvironmentLoaded) {
      return (
        <p className="App-loading">Loading environment, won't be a second...</p>
      );
    }

    return (
      <div className="app-background">
        <div className="App">
          <BrowserRouter>
            <AppContextContainer>
              <Notifications />

              <AppRouter>
                <ErrorHandler>
                  <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route
                      path="/mailbox/:mailBoxName"
                      element={
                        <AuthRoute>
                          <InboxContainer />
                        </AuthRoute>
                      }
                    />
                    <Route
                      path="/mailbox/:mailBoxName/listing/:listingId"
                      element={
                        <AuthRoute>
                          <InboxContainer />
                        </AuthRoute>
                      }
                    />
                    <Route
                      path="/mailbox/:mailBoxName/thread/:threadId/:homeCode"
                      element={
                        <AuthRoute>
                          <ThreadContainer />
                        </AuthRoute>
                      }
                    />
                    <Route
                      path="/search/bcom/conversation/:guestEmail/:conversationId/"
                      element={
                        <AuthRoute>
                          <SearchContainer />
                        </AuthRoute>
                      }
                    />
                    <Route
                      path="/search/bcom/:guestEmail/:platformRef?"
                      element={
                        <AuthRoute>
                          <SearchContainer />
                        </AuthRoute>
                      }
                    />
                    <Route
                      path="/search/vrbo/:vrboListingId/:platformRef?"
                      element={
                        <AuthRoute>
                          <SearchContainer />
                        </AuthRoute>
                      }
                    />
                    <Route
                      path="/search/expedia/:expediaListingId"
                      element={
                        <AuthRoute>
                          <SearchContainer />
                        </AuthRoute>
                      }
                    />

                    <Route
                      path="/not-found"
                      element={
                        <AuthRoute>
                          <NotFound />
                        </AuthRoute>
                      }
                    />
                    <Route
                      path="*"
                      element={
                        <AuthRoute>
                          <Empty />
                        </AuthRoute>
                      }
                    />
                  </Routes>
                </ErrorHandler>
              </AppRouter>
            </AppContextContainer>
          </BrowserRouter>
        </div>
      </div>
    );
  }
}
